export function listingUnitPrice(listing) {
  const price = Math.max(0, Number(listing?.price) || 0);
  const quantity = Math.max(1, Math.floor(Number(listing?.quantity) || 1));
  return price / quantity;
}

export function medianUnitPrice(listings, itemId) {
  const prices = (Array.isArray(listings) ? listings : [])
    .filter(listing => listing?.item_id === itemId)
    .map(listingUnitPrice)
    .filter(price => Number.isFinite(price) && price > 0)
    .sort((left, right) => left - right);
  if (!prices.length) return null;
  const middle = Math.floor(prices.length / 2);
  return prices.length % 2
    ? prices[middle]
    : (prices[middle - 1] + prices[middle]) / 2;
}

export function listingPriceBand(quantity, baseValue) {
  const parsedQuantity = Number(quantity);
  const parsedBaseValue = Number(baseValue);
  if (
    !Number.isInteger(parsedQuantity)
    || parsedQuantity < 1
    || parsedQuantity > 999
    || !Number.isInteger(parsedBaseValue)
    || parsedBaseValue < 1
  ) {
    return null;
  }
  return {
    minPrice: Math.max(1, Math.floor((parsedBaseValue * parsedQuantity) / 5)),
    maxPrice: Math.min(100000000, parsedBaseValue * parsedQuantity * 5),
  };
}

export function listingEconomics(quantity, price, owned = 999, baseValue = 0) {
  const parsedQuantity = Number(quantity);
  const parsedPrice = Number(price);
  const maximum = Math.max(0, Math.min(999, Math.floor(Number(owned) || 0)));
  const band = listingPriceBand(parsedQuantity, baseValue);
  const valid = Number.isInteger(parsedQuantity)
    && parsedQuantity >= 1
    && parsedQuantity <= maximum
    && Number.isInteger(parsedPrice)
    && band
    && parsedPrice >= band.minPrice
    && parsedPrice <= band.maxPrice;
  if (!valid) {
    return {
      valid: false,
      quantity: parsedQuantity,
      price: parsedPrice,
      maximum,
      fee: 0,
      net: 0,
      unitPrice: 0,
      minPrice: band?.minPrice || 0,
      maxPrice: band?.maxPrice || 0,
    };
  }
  const fee = Math.max(1, Math.floor(parsedPrice * 0.005));
  return {
    valid: true,
    quantity: parsedQuantity,
    price: parsedPrice,
    maximum,
    fee,
    net: parsedPrice - fee,
    unitPrice: parsedPrice / parsedQuantity,
    minPrice: band.minPrice,
    maxPrice: band.maxPrice,
  };
}

export function verifiedTradeXp(verifiedScore) {
  const score = Math.max(0, Math.min(500, Math.floor(Number(verifiedScore) || 0)));
  if (score === 0) return 0;
  return Math.min(60, 8 + Math.floor(score / 5));
}

export function verifiedTradeAward(receipt, previousMarketScore = 0) {
  const exact = Number(receipt?.verified_score);
  if (Number.isInteger(exact) && exact >= 0 && exact <= 250) {
    return { points: exact, exact: true };
  }

  // Rolling deploys can briefly pair this client with the previous RPC shape.
  // Reconcile that completed transaction without letting its user-priced
  // listing inflate client progression.
  const current = Number(receipt?.market_score);
  const previous = Number(previousMarketScore);
  if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;
  return {
    points: Math.max(0, Math.min(250, Math.floor(current - previous))),
    exact: false,
  };
}

export function sortMarketListings(listings, mode = 'newest') {
  return [...(Array.isArray(listings) ? listings : [])].sort((left, right) => {
    if (mode === 'unit-low') return listingUnitPrice(left) - listingUnitPrice(right);
    if (mode === 'unit-high') return listingUnitPrice(right) - listingUnitPrice(left);
    if (mode === 'quantity') return Number(right.quantity) - Number(left.quantity);
    const rightTime = new Date(right.created_at).getTime();
    const leftTime = new Date(left.created_at).getTime();
    return (Number.isFinite(rightTime) ? rightTime : 0) - (Number.isFinite(leftTime) ? leftTime : 0);
  });
}
